import { useDisplayAds, initAds, displayAddSlot } from "@/logic/ads";

export function Ad() {
  if(!useDisplayAds()) {
    return null;
  }

  return <div className="flex flex-row justify-center">
    <div ref={initAd} id='headerSlot'></div>
  </div>
}

function initAd(element: any) {
  if(!element) return;
  if(!element.initializedAd) {
    initAds();
    displayAddSlot(element.id, true);
    element.initializedAd = true;
  }
}
